import React, { useEffect, useState } from 'react'
import '../styles/program.scss'
//import DatePickerContainer from '../datepicker/DatePickerContainer'
//import CONSTANTS from '../movielist-constants'
//import xml2js from '../../lib/xml-to-js';
//import DayPicker from 'react-day-picker';
//import moment from 'moment'
//import downarrow from './images/down-arrow-backup-2-svgrepo-com (1).svg'
import check from "../images/check-mark.svg";
//import checkIcon from "./images/check-mark.svg";


export default function Region({ allOrganizers, setOrgPerRegion, regarr, setRegarr  }) {
   //const [chosenRegion, setChosenRegion] = useState([]);

  //  console.log(regarr, 'regarr')
    const [isOpen, setIsOpen] = useState(false);
   // const [chosenRegion, setChosenRegion] = useState('Vælge region');
  // console.log(chosenRegion)
    let arr = [];

    allOrganizers.filter((i) => arr.push(i.region))
 
    function toFindDuplicates(arr) {
        const uniqueElements = new Set(arr);
        // const filteredElements =
        arr.filter((item) => {
            if (uniqueElements.has(item)) {
                // uniqueElements.delete(item);
            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }

    const regions = toFindDuplicates(arr);
    

    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }

    function handleCheck(item) {
       // console.log(item, 'item')
        //setChosenRegion([e])
        if (regarr.includes(item)) {

            setRegarr(regarr.filter(r => { return r !== item }))
            //regarr.pop(item.name)
        }
        else setRegarr([...regarr, item])

    }
    useEffect(() => {
      regarr && setOrgPerRegion([...regarr])
    }, [])
   
       // setIsOpen(false);

        //const sortetOrg = _.filter(allOrganizers, (org) => { return org.region === e })
        //sortetOrg.length && setOrgPerRegion(sortetOrg)
        //setResetCinema(true)
    
 
    return (
        
        <div className=" dropdownContainer">
                   
            <div className="chooseRegion" style={{
                borderBottomLeftRadius: isOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isOpen ? '0px' : '8px',
            }}>
                            <div
                                style={{
                                    position: "relative",

                                    boxSizing: "border-box",
                                 
                                }}
                            >
                        <p style={{ paddingTop: '10px', fontSize: '18px', paddingLeft: '16px', letterSpacing: '0.54px' }}>{regarr && regarr?.length === 1 ? regarr[0] : regarr?.length > 0 ? 'Valgte regioner' : 'Region'}</p>
                        {regarr?.length > 0 && regarr?.length && < span className="one">{regarr.length}</span>  }
                               
                        <button className='chooseBtn'
                                    onClick={handleRegionArrrow}
                                   
                                >
                                    <p className={isOpen ? "rotated" : ""}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                    <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                    </p>
                                </button>
                            </div>
                    {isOpen && (
                        <div className='scroll'
                                    style={{
                                      //  borderTop: "1px solid #757575",
                                backgroundColor: "#2B3040",
                                        paddingBottom:'10px',
                                zIndex: 100, maxHeight: '270px', overflowX: 'auto',
                                        position: 'relative', width: '100%', top: '-1px',
                                    }}
                        >
                            {regions && regions.map((item,index) => (
                                <div key={index } style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "44px",
                                    padding: "10px", width: '95%', borderRadius: '6px',
                                    backgroundColor:regarr.length && regarr.includes(item) ? '#3E455C' : ''
                                }} onClick={()=> handleCheck(item)}>
                                    <p style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: 500, letterSpacing: '0.54px' }}>{item}</p>
                                  
                                        {regarr.length && regarr.includes(item) ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                            <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                        </svg>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                        </svg>}
                                   
                                </div>
                            ))
                            }
                           
                                </div>
                            )}
                        </div>
                   
                    
                </div>
               

           
        )
}